const AddAPlanLink = {
  title: {
    HOL: "Do you have another policy?",
    Any: "Do you have another plan?"
  },
  description: {
    HOL: "Add it to Customer Online here",
    Any: "Add it to Member Online here"
  },
  ariaLabel: {
    HOL: "Add another plan to Customer Online",
    Any: "Add another plan to Member Online"
  }
};

export default AddAPlanLink;
